import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../common/shared.module';
import { PgRendererComponent } from './pg-renderer.component';
import { ItemBodyComponent } from './item-body/item-body.component';
import { PageNavComponent } from './page-nav/page-nav.component';
import { TopNavComponent } from './top-nav/top-nav.component';
import { NavButtonComponent } from './top-nav/nav-button/nav-button.component';
import { TimerComponent } from './top-nav/timer/timer.component';
import { ItemBodyPanelComponent } from './item-body/item-body-panel/item-body-panel.component';
import { NavigationModalComponent } from './navigation-modal/navigation-modal.component';
import { TestFormValidationComponent } from './test-form-validation/test-form-validation.component';
import { TestNavigationService } from '../../services/test-navigation.service';
import { LoggerService } from '../../services/logger.service';
import { PreventDoubleClickDirective } from 'app/directives/prevent-double-click.directive';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    SharedModule
  ],
  declarations: [
    PreventDoubleClickDirective,
    PgRendererComponent,
    ItemBodyComponent,
    PageNavComponent,
    TopNavComponent,
    NavButtonComponent,
    TimerComponent,
    ItemBodyPanelComponent,
    NavigationModalComponent,
    TestFormValidationComponent
  ],
  providers: [
    LoggerService,
    TestNavigationService
  ]
})
export class PgRendererModule { }



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/pg-renderer.module.ts